import axiosInstanceNode from "@/api/axiosInstanceNode";


// get company profile api
export const getCompanyProfile = async () => {
  try {
    const response = await axiosInstanceNode.get("/auth/website-services");
    return response.data;
  } catch (error) {
    console.error("Error getting company profile:", error);
    throw error;
  }
};

// update company profile api
export const updateCompanyProfile = async (data) => {
  try {
    const response = await axiosInstanceNode.patch("/auth/website-data", data);
    return response.data;
  } catch (error) {
    console.error("Error updating company profile:", error);
    throw error;
  }
};